import { render } from "./xiaohsCardItem.vue?vue&type=template&id=580bc844&scoped=true"
import script from "./xiaohsCardItem.vue?vue&type=script&lang=js"
export * from "./xiaohsCardItem.vue?vue&type=script&lang=js"

import "./xiaohsCardItem.vue?vue&type=style&index=0&id=580bc844&lang=scss&scoped=true"

import exportComponent from "/Users/tangyinbo/workspace/front/syb/syb_webchat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-580bc844"]])

export default __exports__